import React from "react";
import { Bell, Volume2, Key, ExternalLink, Copy, Phone } from "lucide-react";
import TemplatePreview from "./TemplatePreview";
import TemplateSetupForm from "./TemplateSetupForm";

const templateData = {
  categories: {
    Marketing: {
      icon: Bell,
      subcategories: [
        {
          label: "Default",
          desc: "Send messages with media and customised buttons to engage your customers."
        },
        {
          label: "Catalogue", 
          desc: "Send messages that drive sales by connecting your product catalogue."
        },
        {
          label: "Flows",
          desc: "Send a form to capture customer interests, appointment requests or run surveys."
        },
        {
          label: "Calling permissions request",
          desc: "Ask customers if you can call them on WhatsApp."
        }
      ]
    },
    Utility: {
      icon: Volume2,
      subcategories: [
        {
          label: "Default",
          desc: "Send messages with media and customised buttons to engage your customers."
        },
        {
          label: "Catalogue",
          desc: "Send messages that drive sales by connecting your product catalogue."
        },
        {
          label: "Flows", 
          desc: "Send a form to capture customer interests, appointment requests or run surveys."
        }
      ]
    },
    Authentication: {
      icon: Key,
      subcategories: [
        {
          label: "one_time otp",
          desc: "One-time password for secure authentication."
        }
      ]
    }
  },
  
  previews: {
    Marketing: {
      image: "https://images.unsplash.com/photo-1542838132-92c53300491e?w=400&h=200&fit=crop",
      title: "🛍️ Fresh Groceries Available!",
      message: "Hey there! Check out our fresh groceries now!",
      subtitle: "Use code HEALTH to get additional 10% off on your entire purchase.",
      buttons: [
        { icon: <ExternalLink size={14} />, text: "Shop now", color: "text-blue-600" },
        { icon: <Copy size={14} />, text: "Copy code", color: "text-blue-600" }
      ],
      goodFor: "Welcome messages, promotions, offers, coupons, newsletters, announcements",
      customizable: "Header, Body, Footer, Button"
    },
    Utility: {
      image: "https://images.unsplash.com/photo-1611224923853-80b023f02d71?w=400&h=200&fit=crop",
      title: "📦 Order Update",
      message: "Your order #12345 has been shipped!",
      subtitle: "Expected delivery: Tomorrow by 6 PM. Track your package below.",
      buttons: [
        { icon: <ExternalLink size={14} />, text: "Track package", color: "text-green-600" },
        { icon: <Phone size={14} />, text: "Contact support", color: "text-green-600" }
      ],
      goodFor: "Order updates, appointment reminders, shipping notifications, account alerts",
      customizable: "Header, Body, Footer, Button"
    },
    Authentication: {
      image: null,
      title: "🔐 Security Code",
      message: "Your WhatsApp verification code is:",
      subtitle: "Do not share this code with anyone. It expires in 10 minutes.",
      code: "847293",
      buttons: [],
      goodFor: "Login verification, two-factor authentication, password resets",
      customizable: "Body, Footer"
    }
  }
};

const TemplateSetup = ({
  setSelectedCategory,
  setSelectedSubCat,
  selectedSubCat,
  selectedCategory
}) => {
  const isSubcategoryDisabled = (category, subLabel) => {
    if (category === "Authentication") {
      return subLabel !== "one_time otp";
    }
    return subLabel !== "Default";
  };

  const currentSubcategories = templateData.categories[selectedCategory]?.subcategories || [];

  const handleCategoryChange = (category) => {
    setSelectedCategory(category);
    
    const newSubcategories = templateData.categories[category]?.subcategories || [];
    let defaultSub;

    if (category === "Authentication") {
      defaultSub = newSubcategories.find(s => s.label === "one_time otp");
    } else {
      defaultSub = newSubcategories.find(s => s.label === "Default") || newSubcategories[0];
    }

    if (defaultSub) {
      setSelectedSubCat(defaultSub.label);
    }
  };

  const currentPreviewData = templateData.previews[selectedCategory] || null;

  return (
    <div className="h-full bg-gradient-to-b from-blue-50 to-white p-6 flex gap-10 items-start">
      <TemplateSetupForm
        selectedCategory={selectedCategory}
        setSelectedCategory={handleCategoryChange}
        selectedSubCategory={selectedSubCat}
        setSelectedSubCategory={setSelectedSubCat}
        categories={templateData.categories}
        subcategories={currentSubcategories}
        isSubcategoryDisabled={isSubcategoryDisabled}
      />
      <TemplatePreview previewData={currentPreviewData} />
    </div>
  );
};

export default TemplateSetup;